import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Stack,
} from '@mui/material';
import Description from '@mui/icons-material/Description';
import Highlight from '@mui/icons-material/Highlight';

const DocumentPreview = ({ documentContent, skills, open, onClose }) => {

  const highlightSkills = (text, skills) => {
    if (!skills || skills.length === 0) return text;

    let highlightedText = text;
    skills.forEach(skill => {
      const regex = new RegExp(`(${skill})`, 'gi');
      highlightedText = highlightedText.replace(regex,
        `<mark style="background-color: #fff3cd; color: #856404; padding: 2px 4px; border-radius: 3px; font-weight: 600;">$1</mark>`
      );
    });

    return highlightedText;
  };

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { height: '80vh', maxHeight: '80vh' }
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Description color="primary" />
        <Typography variant="h6" component="span">
          Resume Preview
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
          Live Document Review
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        {documentContent ? (
          <Box>
            {/* Skills Legend */}
            {skills && skills.length > 0 && (
              <Paper sx={{ p: 2, mb: 2, backgroundColor: '#f8f9fa' }}>
                <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Highlight color="warning" />
                  Highlighted Must-Have Skills:
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {skills.map((skill, index) => (
                    <Chip
                      key={index}
                      label={skill}
                      size="small"
                      sx={{
                        backgroundColor: '#fff3cd',
                        color: '#856404',
                        '&:hover': { backgroundColor: '#ffeaa7' }
                      }}
                    />
                  ))}
                </Stack>
              </Paper>
            )}

            {/* Document Content */}
            <Paper sx={{
              p: 3,
              backgroundColor: '#fafafa',
              maxHeight: '500px',
              overflow: 'auto',
              fontFamily: 'monospace',
              fontSize: '0.875rem',
              lineHeight: 1.6,
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word'
            }}>
              <div
                dangerouslySetInnerHTML={{
                  __html: highlightSkills(documentContent, skills)
                }}
              />
            </Paper>
          </Box>
        ) : (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="text.secondary" variant="h6">
              No document content available
            </Typography>
            <Typography color="text.secondary">
              Upload a resume to preview its content
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button 
          onClick={onClose} 
          color="primary"
          sx={{
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.04)',
              transform: 'scale(1.02)'
            },
            '&:active': {
              transform: 'scale(0.98)'
            },
            transition: 'all 0.2s ease'
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentPreview;
